import type { NextRequest } from "next/server"
import { NextResponse } from "next/server"

const AUTH_COOKIE_NAME = "wp_session_token"
const LOGIN_PATH = "/entrar"
const ACCOUNT_PATH_PREFIX = "/minha-conta"
const CHECKOUT_PATH = "/finalizar-comprar"

const isProtectedPath = (pathname: string): boolean => {
  return (
    pathname === ACCOUNT_PATH_PREFIX ||
    pathname.startsWith(`${ACCOUNT_PATH_PREFIX}/`) ||
    pathname === CHECKOUT_PATH
  )
}

const toCallbackValue = (request: NextRequest): string => {
  return `${request.nextUrl.pathname}${request.nextUrl.search}`
}

const toLoginRedirectUrl = (request: NextRequest): URL => {
  const loginUrl = new URL(LOGIN_PATH, request.url)
  loginUrl.searchParams.set("callback", toCallbackValue(request))
  return loginUrl
}

export const middleware = (request: NextRequest) => {
  if (!isProtectedPath(request.nextUrl.pathname)) {
    return NextResponse.next()
  }

  const hasSessionCookie = Boolean(
    request.cookies.get(AUTH_COOKIE_NAME)?.value?.trim()
  )

  if (hasSessionCookie) {
    return NextResponse.next()
  }

  return NextResponse.redirect(toLoginRedirectUrl(request))
}

export const config = {
  matcher: ["/minha-conta/:path*", "/finalizar-comprar"],
}
